// extracted by mini-css-extract-plugin
export default {"selectCustomer":"CustomersTableBody_selectCustomer__FZU2C","row":"CustomersTableBody_row__HDVyg"};